module.exports = __webpack_public_path__ + "img/6083bca9ef973de32e2d28444d999c08.png";